import { Timezone } from './time';

export type PrimitiveSite = { [key in keyof Site]?: | string | number | { href: string }[] };

export class Site {
    public readonly id: number;
    public readonly latitude: number;
    public readonly longitude: number;
    public readonly state: string;
    public readonly country: string;
    public readonly location: string;
    public readonly vector: string;
    public readonly utcOffset: number;
    public readonly publiclyVisible: boolean;
    public readonly position: [number, number];
    public readonly stations: { href: string }[];

    public constructor(data: PrimitiveSite) {
        Object.assign(this, data);
        this.position = [this.longitude, this.latitude];
    }

    public get displayName(): string {
        return `${this.state} ${this.location} ${this.vector}`;
    }

    public utcOffsetForZone(timezone: Timezone): number {
        return timezone === 'UTC' ? 0 : this.utcOffset;
    }
}
